var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"cart-login-note"},[_vm._v("\n  購入にはLedianの会員登録が必要です。"),_c('br'),_vm._v("\n  登録済みの方はログインしてください。\n")])}]

export { render, staticRenderFns }